import { Editor, StyleProp } from '@tldraw/tldraw'
import { useMemo } from 'react'

export function useUpdateStyle(editor: Editor) {
  return useMemo(() => {
    return function handleStyleChange<T>(style: StyleProp<T>, value: T) {
      editor.batch(() => {
        if (editor.isIn('select')) {
          editor.setStyleForSelectedShapes(style, value)
        }
      })
    }
  }, [editor])
}
